import { Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlValueAccessor } from '../base-control-value-accessor';

@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['../../styles/form-input.scss', './text-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextInputComponent),
      multi: true
    }
  ]
})

export class TextInputComponent extends BaseControlValueAccessor<string> implements OnInit, OnDestroy {

  @Input() formControl: FormControl;
  @Input() config: any;
  @Input() type: string;
  @Input() multiline: boolean;
  @Input() minlength: any;
  @Input() maxlength: any;
  @Input() autoCompleteValue: string;
  @Input() etsMandate = false;
  @Input() styleApplied: string;
  @Input() errorMsgNoWrap: boolean;
  @Input() showErrorBorder : boolean = true;
  @Input() showCross:boolean;
  @Input() placeholder:string
  @Input() elementKey:string

  @Output() changeCallback = new EventEmitter();
  @Output() clearFormCallback = new EventEmitter();
  errorState = false;

  ngOnInit() {
    if (this.formControl) {
      this.formControl.markAsUntouched();
    }
  }

  onInputChange(event): void {
    this.onChange(this.value);
    if (this.changeCallback) {
      this.changeCallback.emit(this.value);
    }
  }

  showError(): boolean {
    if (this.formControl.errors && this.formControl.errors.secure) {
      return false;
    } else {
      this.errorState = Boolean(this.formControl && this.formControl.errors && this.formControl.dirty);
      return Boolean(this.formControl && this.formControl.errors && this.formControl.dirty);
    }
  }

  checkInput(event,elementKey){
    return (elementKey && elementKey=='email') ? ( (event.charCode == 95) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 64 && event.charCode <= 90) || ((event.charCode >= 48 && event.charCode <= 57)) || (event.charCode == 32) || (event.charCode == 39)  || (event.charCode >= 44 && event.charCode <= 47 )) : 
     ((event.charCode >= 97 && event.charCode <= 122) || (event.charCode >= 64 && event.charCode <= 90) || ((event.charCode >= 48 && event.charCode <= 57)) || (event.charCode == 32) || (event.charCode == 39)  || (event.charCode >= 44 && event.charCode <= 47 ));
  }
  validateInput(event) {
    const clipboardData = event.clipboardData || window.Clipboard;
    const pastedText = clipboardData.getData('text');
    const specialCharsRegex = /[!#$%^&*()?":;`{}|<>]/;
    if (specialCharsRegex.test(pastedText)) {
      event.preventDefault();
      return false;
    }
    return true;
  }
    ngOnDestroy() {
    this.formControl.updateValueAndValidity({ emitEvent: false });
  }

}
